// Shared browser-side fetch posture for /v1/admin/*.
//
// Same-origin so the CF_Authorization cookie reaches Access in front of
// books.grandvision.co (credentials:"omit" was why identity never arrived).
// Authorization is omitted when the token is empty: production holds
// ADMIN_TOKEN in the Pages Function, not in the page.

export const ADMIN_FETCH_CREDENTIALS: RequestCredentials = "same-origin";

export function adminRequestHeaders(
  token: string,
  extra: Record<string, string>,
): Record<string, string> {
  const headers: Record<string, string> = { ...extra };
  if (token.length > 0) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}
